import React, { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';

interface Props {}

export default function ErrorPage(props: Props): ReactElement {
  const localizationService = useLocalization();
  return <div>Error</div>;
}
